<gk-payment-success (redirectTrigger)="handleRedirectTrigger()"></gk-payment-success>
